define("settings/controllers/users", ["exports", "@ember/controller", "@ember/object", "@ember/service"], function (_exports, _controller, _object, _service) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2;
  0; //eaimeta@70e063a35619d71f0,"@ember/controller",0,"@ember/object",0,"@ember/service"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  let UsersController = _exports.default = (_class = class UsersController extends _controller.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "intl", _descriptor, this);
      _initializerDefineProperty(this, "subscriptions", _descriptor2, this);
    }
    get availableSeats() {
      const availableSeats = this.totalUsers - this.users.length;
      return availableSeats > 0 ? availableSeats : 0;
    }
    get needsPlanUpgrade() {
      return !this.subscriptions.subscriptionPlan.canAddUsers;
    }
    get canUpgrade() {
      return this.subscriptions.canUpgrade;
    }
    get isMobileSubscription() {
      return this.subscriptions.isMobileSubscription;
    }
    get mobileUpgradeText() {
      return this.subscriptions.isEligibleForTrial ? this.intl.t('plans.mobile.add_users_trial', {
        platform: this.subscriptionPlatform
      }) : this.intl.t('plans.mobile.add_users', {
        platform: this.subscriptionPlatform
      });
    }
    get showMobileRedirect() {
      return this.isMobileSubscription && this.availableSeats === 0 && this.subscriptions.canUpgrade;
    }
    get subscriptionPlatform() {
      return this.subscriptions.platform;
    }
    get totalUsers() {
      return this.currentAccount.totalUsers ?? 1;
    }
    openMobileRedirectModal() {
      this.subscriptions.openMobileRedirectModal();
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "openMobileRedirectModal", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "openMobileRedirectModal"), _class.prototype)), _class);
});